import React from 'react';
import { Pencil, Trash2, AtSign, Paperclip, Sparkles } from 'lucide-react';

const WidgetHeader = ({ 
  showEditor, 
  tempPrompt, 
  setTempPrompt, 
  isVisualization, 
  tempChartPrompt, 
  setTempChartPrompt,
  ragPrompt,
  handleSave,
  handleCancel,
  handleEditorToggle,
  onDelete,
  id
}) => {
  return (
    <div className="bg-gray-50 px-4 py-2 border-b border-gray-200 flex justify-between items-center">
      {showEditor ? (
        <div className="flex-1 flex flex-col gap-2">
          <input
            type="text"
            value={tempPrompt}
            onChange={(e) => setTempPrompt(e.target.value)}
            placeholder="Prompt"
            className="w-full px-3 py-1.5 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500/30"
          />
          {isVisualization && (
            <input
              type="text"
              value={tempChartPrompt}
              onChange={(e) => setTempChartPrompt(e.target.value)}
              placeholder="Chart Prompt"
              className="w-full px-3 py-1.5 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500/30"
            />
          )}
        </div>
      ) : (
        <div className="flex-1 overflow-hidden">
          <span className="text-xs text-gray-500 italic">Prompt: </span>
          <span className="text-xs text-gray-700 truncate">{ragPrompt}</span>
        </div>
      )}
      
      {showEditor ? (
        <div className="flex gap-2 ml-4">
          <button 
            onClick={handleSave}
            className="px-3 py-1 text-xs bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
          >
            Save
          </button>
          <button 
            onClick={handleCancel}
            className="px-3 py-1 text-xs bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 transition-colors"
          >
            Cancel
          </button>
        </div>
      ) : (
        <div className="flex items-center gap-2 text-gray-500">
          <AtSign size={16} className="cursor-pointer hover:text-primaryDark transition-colors" />
          <Paperclip size={16} className="cursor-pointer hover:text-primaryDark transition-colors" />
          <Sparkles size={16} className="cursor-pointer hover:text-primaryDark transition-colors" />
          <Pencil 
            size={16} 
            onClick={handleEditorToggle} 
            className="cursor-pointer hover:text-primaryDark transition-colors"
          />
          <Trash2 
            size={16} 
            onClick={() => onDelete(id)} 
            className="cursor-pointer hover:text-red-600 transition-colors"
          />
        </div>
      )}
    </div>
  );
};

export default WidgetHeader;